import { useContext } from 'react'

import { UploadContext } from '../../contexts/uploadContext'
import { reviewText } from './constants'

import MessageBox from 'components/common/MessageBox '
import { TakePhotoButton } from '../TakePhotoButton'
import { useUploadField } from './hooks'

export const UploadField = ({ side = "front", ...props}) => {
	const { uploadedFilesState, docTypeState } = useContext(UploadContext)
	const [ docType ] = docTypeState

	const isFront = side === "front"

	const {
		slug,
		label,
		modifyPayloadKeys,
		onChange
	} = props
	
	const { 
		fieldLabel,
		showMask,
		fieldDescription,
		hasSimpleDescription,
		hasMessage,
	} = useUploadField(props)
	
	const textReview = slug === "residence_proof" ? reviewText.residence : reviewText.document

	return (
		<div className="simple-upload__container">

			<p className="iq-field-base__label">
				{fieldLabel || label}
				<span className="iq-field-base__required"> *</span>
			</p>

			<TakePhotoButton
				showMask={showMask}
				maskType={docType}
				reviewImageText={textReview}
				side={side}
				docType={docType}
				fileReference={slug}
				filesReferencesState={uploadedFilesState}
				modifyPayloadKeys={modifyPayloadKeys}
				facing="environment"		
				onChange={onChange}
			/>

			{ isFront && hasSimpleDescription && 
				<p className="simple-upload__desc">{fieldDescription}</p> }

			{ isFront && hasMessage && 
					<MessageBox>{fieldDescription}</MessageBox>}

		</div>
	)
}